// extracted by mini-css-extract-plugin
export default {"inputWrapper":"CustomRadioButton_inputWrapper__xC3yl"};